var typesButton = {
  addToBag: 'adicionar-a-sacola',
  oneTouch: 'comprar-agora',
  pickupStore: 'retira-loja',
  typeFloat: 'botao-flutuante'
};
var getTypeButton = function getTypeButton(typeButton) {
  return typesButton[typeButton] || typesButton.addToBag;
};
export default getTypeButton;